import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getSMSSettings = ({ sms }: Partial<ChatsChannelBase>) => {
  if (!sms) return null;

  const url = `sms://${sms}`;

  return {
    provider: ChatsChannelType.sms,
    link: { url, options: { openCurrentPage: true } },
    title: 'SMS',
    icon: getChatIcon(ChatsChannelType.sms),
    color: 'rgb(1, 214, 19)'
  } as ChatsChannelSetting;
};
